import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Stack } from '@mui/material';

import { MplBottomSheet, MplButton, MplIconMessage } from '@mopla/ui';

import { TCTAConfig } from '../hooks/types';

interface IDTicketCTASectionProps {
	config: NonNullable<TCTAConfig>;
	isLoading?: boolean;
	onHeightChange?: (height: number) => void;
}

export const DTicketCTASection = ({
	config,
	isLoading = false,
	onHeightChange,
}: IDTicketCTASectionProps) => {
	const { t } = useTranslation('userDTicket');
	const contentRef = useRef<HTMLDivElement>(null);

	const hasButton = Boolean(config.buttonLabelKey && config.onAction);

	useEffect(() => {
		if (contentRef.current && onHeightChange) {
			const resizeObserver = new ResizeObserver((entries) => {
				for (const entry of entries) {
					onHeightChange(entry.contentRect.height + 50); // +50 for padding
				}
			});
			resizeObserver.observe(contentRef.current);
			return () => resizeObserver.disconnect();
		}
	}, [onHeightChange]);

	return (
		<MplBottomSheet open isStatic maxHeight="auto">
			<Stack ref={contentRef} gap={2} sx={{ px: 2, paddingTop: 2 }}>
				<MplIconMessage
					type={config.iconType}
					variant={config.variant}
					message={t(config.messageKey, config.messageValues)}
					dataTestid="dticket-CTASection-iconMessage"
				/>
				{hasButton && (
					<MplButton
						variant="contained"
						onClick={config.onAction}
						showLoader={isLoading}
						disabled={isLoading}
						testId="dticket-CTASection-action-button"
					>
						{t(config.buttonLabelKey ?? '')}
					</MplButton>
				)}
			</Stack>
		</MplBottomSheet>
	);
};
